import cn from "classnames";
import style from "./style.module.css";
import { CompositeIcon } from "@/shared/components/assessment/CompositeIcon/CompositeIcon";
import { StrengthPill } from "@/shared/components/assessment/StrengthPill/StrengthPill";

export interface AssessmentTemplateCardHeaderProps {
  className?: string;
  compositeScore: number;
  compositeTitle: string;
  icon: string | null;
}

export default function AssessmentTemplateCardHeader({
  className,
  compositeTitle,
  compositeScore,
  icon,
}: AssessmentTemplateCardHeaderProps) {
  return (
    <>
      <header className={cn(style.header, className)}>
        <CompositeIcon icon={icon} className={style.icon} />
        <h2 className={style.title}>{compositeTitle}</h2>
        <StrengthPill score={compositeScore} />
      </header>
    </>
  );
}
